import styles from "./RegistryImportanceSection.module.css";

function RegistryImportanceSection() {
  return (
    <section
      className={styles.section}
      aria-labelledby="registry-importance-section-title"
    >
      <div className={styles.container}>
        <div className={styles.row}>
          <h2 id="registry-importance-section-title" className={styles.title}>
            The importance of this registry
          </h2>

          <div className={styles.copyBlock}>
            <p className={styles.copyParagraph}>
              A transparent biodiversity credit registry is essential for
              building trust and integrity in an emerging nature market. By
              clearly recording credit issuance, ownership and retirement, this
              registry helps avoid double counting, unclear claims and
              traceability issues.
            </p>
            <p className={styles.copyParagraph}>
              For businesses, a robust registry provides confidence that
              biodiversity credits represent real, additional outcomes for
              nature. This is particularly important where biodiversity projects
              may generate both voluntary biodiversity credits and mandatory
              Biodiversity Net Gain (BNG) units. Transparent registries ensure
              these are clearly distinguished and not sold twice.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RegistryImportanceSection;
